import { SxProps, Theme } from '@mui/material'

export const paymentLogoStyle: SxProps<Theme> = {
  display: 'flex',
  '& > svg': {
    height: { xs: 16, sm: 20 },
    width: 'auto',
  },
}
